import { config } from '../config';
import type { RedirectMap } from '../../types';

export const redirectMap: RedirectMap = {
  guest: {
    '../main/': { redirect: `/${config.mvcVersion}/main/` },
    '../guest_sauton/guest.html': { redirect: `/${config.mvcVersion}/guest_sauton/report` },
    '../guest/guest.html': { navigate: '/report' },
  },
  sauton: {
    '../main/': { redirect: `/${config.mvcVersion}/main/` },
    '../guest_sauton/guest.html': { navigate: '/report' },
    '../guest/guest.html': { redirect: `/${config.mvcVersion}/guest/report` },
  },
};
